import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import {UntypedFormControl} from '@angular/forms';
import {MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS} from '@angular/material-moment-adapter';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import {MatDatepicker} from '@angular/material/datepicker';
import { ApicallService } from '../../services/apicall.service';

import * as _moment from 'moment';
import {default as _rollupMoment, Moment} from 'moment';
const moment = _rollupMoment || _moment;

export const MY_FORMATS = {
  parse: {
    dateInput: 'MM/YYYY',
  },
  display: {
    dateInput: 'MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'app-month-year-picker',
  templateUrl: './month-year-picker.component.html',
  styleUrls: ['./month-year-picker.component.scss'],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },

    {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
  ],
})
export class MonthYearPickerComponent implements OnInit {

  startOfMonth: any;
  endOfMonth: any;

  date: any = new UntypedFormControl(moment());

  @Input('disable') disable;

  @Input('pickerType') pickerType;

  @Input('disableGlobalDate') disableGlobalDate;

  @Input() set initDate(value: any) {
    if(value == null){
      this.date = new UntypedFormControl(null);
    }
    if (value != undefined) {
      this.date =new UntypedFormControl(moment(value));
    }
  }

  @Input() set clearData(value: any){
    if(value == 'YES'){
      this.date = new UntypedFormControl(null);
    }
  }
  
  @Output() monthYearValue: EventEmitter<any> = new EventEmitter();
  @Output() monthYearFormatValue: EventEmitter<any> = new EventEmitter();

  constructor(
    public apiCallService:ApicallService
  ) { }

  ngOnInit() {
    if(this.apiCallService.globalDate != undefined && this.disableGlobalDate == "NO"){
      this.date = this.apiCallService.globalDate;
    }
    if(this.apiCallService.globalDate == undefined && this.disableGlobalDate == "NO"){
      this.date = new UntypedFormControl(moment(null));
    }
    if(this.date.value != undefined){
      this.getFirstAndLastDate(this.date.value._d);
    }
  }
  
  chosenYearHandler(normalizedYear: Moment) {
    const ctrlValue = this.date.value;
    if(ctrlValue == null){
      this.date =new UntypedFormControl(moment());
      return;
    }
    ctrlValue.year(normalizedYear.year());
    this.date.setValue(ctrlValue);
  }

  chosenMonthHandler(normalizedMonth: Moment, datepicker: MatDatepicker<Moment>) {
    const ctrlValue = this.date.value;
    this.apiCallService.globalDate = this.date; 
    ctrlValue.month(normalizedMonth.month());
    this.date.setValue(ctrlValue);
    datepicker.close();
    this.getFirstAndLastDate(this.date.value._d);
  }

  getFirstAndLastDate(data){
    const startOfMonthChangeFormat = moment(data).clone().startOf('month').format('YYYY-MM-DD');
    const endOfMonthChangeFormat   = moment(data).clone().endOf('month').format('YYYY-MM-DD');
    this.monthYearFormatChange([startOfMonthChangeFormat, endOfMonthChangeFormat]);
    var check = moment(data, 'YYYY/MM/DD');
    var month = check.format('M');
    var year  = check.format('YYYY');
    this.monthYearValueChange([this.monthPadding(month), year]);
  }

  monthYearValueChange(data){
    this.monthYearValue.emit(data);
  }

  monthYearFormatChange(data){
    this.monthYearFormatValue.emit(data)
  }

  monthPadding(d) {
    return (d < 10) ? '0' + d.toString() : d.toString();
  }

}
